<button (click)="auth()" class="auth-btn"><img *ngIf="iconPath" [attr.src]="iconPath" [attr.alt]="provider"/>{{ buttonText }}</button>
